import React from 'react';
import { Hero } from '../components/home/Hero';
import { Ticker } from '../components/home/Ticker';
import { Branches } from '../components/home/Branches';
import { StoryTeaser } from '../components/home/StoryTeaser';
import { JoinBanner } from '../components/home/JoinBanner';

/**
 * The front door, not the whole house. Three ways in, one line about who we are,
 * and a door for businesses — everything else lives behind a click.
 */
export function Home() {
  return <>
      <Hero data-id="element-983" data-mp="24gsay0jybhti" />
      <Ticker data-id="element-984" data-mp="24ginokqajori" />
      <Branches data-id="element-985" data-mp="24i3f41hb6rl5" />
      <StoryTeaser data-id="element-986" data-mp="24hk7bdldhjku" />
      <JoinBanner data-id="element-987" data-mp="24j4tofxj9w7m" />
    </>;
}